"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._CachedReadableLiquity = void 0;
/** @internal */
class _CachedReadableLiquity {
    constructor(readable, cache) {
        this._readable = readable;
        this._cache = cache;
    }
    async getTotalRedistributed(...extraParams) {
        var _a;
        return ((_a = this._cache.getTotalRedistributed(...extraParams)) !== null && _a !== void 0 ? _a : this._readable.getTotalRedistributed(...extraParams));
    }
    async getTroveBeforeRedistribution(address, ...extraParams) {
        var _a;
        return ((_a = this._cache.getTroveBeforeRedistribution(address, ...extraParams)) !== null && _a !== void 0 ? _a : this._readable.getTroveBeforeRedistribution(address, ...extraParams));
    }
    async getTrove(address, ...extraParams) {
        const [troveBeforeRedistribution, totalRedistributed] = await Promise.all([
            this.getTroveBeforeRedistribution(address, ...extraParams),
            this.getTotalRedistributed(...extraParams)
        ]);
        return troveBeforeRedistribution.applyRedistribution(totalRedistributed);
    }
    async getNumberOfTroves(...extraParams) {
        var _a;
        return ((_a = this._cache.getNumberOfTroves(...extraParams)) !== null && _a !== void 0 ? _a : this._readable.getNumberOfTroves(...extraParams));
    }
    async getReceiptPerUnderlyingRatios(addresses, vaultTokens, ...extraParams) {
        var _a;
        return (_a = this._cache.getReceiptPerUnderlyingRatios(addresses, vaultTokens, ...extraParams)) !== null && _a !== void 0 ? _a : this._readable.getReceiptPerUnderlyingRatios(addresses, vaultTokens, ...extraParams);
    }
    async getUnderlyingPerReceiptRatios(addresses, vaultTokens, ...extraParams) {
        var _a;
        return (_a = this._cache.getUnderlyingPerReceiptRatios(addresses, vaultTokens, ...extraParams)) !== null && _a !== void 0 ? _a : this._readable.getUnderlyingPerReceiptRatios(addresses, vaultTokens, ...extraParams);
    }
    async getCollPrice(address, ...extraParams) {
        var _a;
        return (_a = this._cache.getCollPrice(address, ...extraParams)) !== null && _a !== void 0 ? _a : this._readable.getCollPrice(address, ...extraParams);
    }
    async getPrices(addresses, ...extraParams) {
        var _a;
        return (_a = this._cache.getPrices(addresses, ...extraParams)) !== null && _a !== void 0 ? _a : this._readable.getPrices(addresses, ...extraParams);
    }
    async getCollPrices(addresses, vaultTokens, underlyingDecimals, ...extraParams) {
        var _a;
        return (_a = this._cache.getCollPrices(addresses, vaultTokens, underlyingDecimals, ...extraParams)) !== null && _a !== void 0 ? _a : this._readable.getCollPrices(addresses, vaultTokens, underlyingDecimals, ...extraParams);
    }
    async getUnderlyingDecimals(vaultTokens, ...extraParams) {
        var _a;
        return (_a = this._cache.getUnderlyingDecimals(vaultTokens, ...extraParams)) !== null && _a !== void 0 ? _a : this._readable.getUnderlyingDecimals(vaultTokens, ...extraParams);
    }
    async getUnderlyingTokens(vaultTokens, ...extraParams) {
        var _a;
        return (_a = this._cache.getUnderlyingTokens(vaultTokens, ...extraParams)) !== null && _a !== void 0 ? _a : this._readable.getUnderlyingTokens(vaultTokens, ...extraParams);
    }
    async getBalances(addresses, ...extraParams) {
        var _a;
        return (_a = this._cache.getBalances(addresses, ...extraParams)) !== null && _a !== void 0 ? _a : this._readable.getBalances(addresses, ...extraParams);
    }
    async getVaultDepositInfo(vaultTokens, receiptPerUnderlyingRatios, underlyingDecimals, ...extraParams) {
        var _a;
        return (_a = this._cache.getVaultDepositInfo(vaultTokens, receiptPerUnderlyingRatios, underlyingDecimals, ...extraParams)) !== null && _a !== void 0 ? _a : this._readable.getVaultDepositInfo(vaultTokens, receiptPerUnderlyingRatios, underlyingDecimals, ...extraParams);
    }
    async getLPBalances(addresses, ...extraParams) {
        var _a;
        return (_a = this._cache.getLPBalances(addresses, ...extraParams)) !== null && _a !== void 0 ? _a : this._readable.getLPBalances(addresses, ...extraParams);
    }
    async getTotal(...extraParams) {
        var _a;
        return (_a = this._cache.getTotal(...extraParams)) !== null && _a !== void 0 ? _a : this._readable.getTotal(...extraParams);
    }
    async getStabilityDeposit(address, ...extraParams) {
        var _a;
        return ((_a = this._cache.getStabilityDeposit(address, ...extraParams)) !== null && _a !== void 0 ? _a : this._readable.getStabilityDeposit(address, ...extraParams));
    }
    async getFarm(address, ...extraParams) {
        var _a;
        return ((_a = this._cache.getFarm(address, ...extraParams)) !== null && _a !== void 0 ? _a : this._readable.getFarm(address, ...extraParams));
    }
    async getBoostedFarm(address, ...extraParams) {
        var _a;
        return ((_a = this._cache.getBoostedFarm(address, ...extraParams)) !== null && _a !== void 0 ? _a : this._readable.getBoostedFarm(address, ...extraParams));
    }
    async getVEYETIStake(address, ...extraParams) {
        var _a;
        return ((_a = this._cache.getVEYETIStake(address, ...extraParams)) !== null && _a !== void 0 ? _a : this._readable.getVEYETIStake(address, ...extraParams));
    }
    async getPoolRewardRate(...extraParams) {
        var _a;
        return ((_a = this._cache.getPoolRewardRate(...extraParams)) !== null && _a !== void 0 ? _a : this._readable.getPoolRewardRate(...extraParams));
    }
    async getYUSDInStabilityPool(...extraParams) {
        var _a;
        return ((_a = this._cache.getYUSDInStabilityPool(...extraParams)) !== null && _a !== void 0 ? _a : this._readable.getYUSDInStabilityPool(...extraParams));
    }
    async getDepositFee(VCInput, VCOutput, ...extraParams) {
        var _a;
        return ((_a = this._cache.getDepositFee(VCInput, VCOutput, ...extraParams)) !== null && _a !== void 0 ? _a : this._readable.getDepositFee(VCInput, VCOutput, ...extraParams));
    }
    async getEstimatedFarmRewards(amount, time, ...extraParams) {
        var _a;
        return ((_a = this._cache.getEstimatedFarmRewards(amount, time, ...extraParams)) !== null && _a !== void 0 ? _a : this._readable.getEstimatedFarmRewards(amount, time, ...extraParams));
    }
    async getEstimatedVeYetiRewards(amount, time, ...extraParams) {
        var _a;
        return ((_a = this._cache.getEstimatedVeYetiRewards(amount, time, ...extraParams)) !== null && _a !== void 0 ? _a : this._readable.getEstimatedVeYetiRewards(amount, time, ...extraParams));
    }
    async getEstimatedYETIPoolRewards(amount, time, ...extraParams) {
        var _a;
        return ((_a = this._cache.getEstimatedYETIPoolRewards(amount, time, ...extraParams)) !== null && _a !== void 0 ? _a : this._readable.getEstimatedYETIPoolRewards(amount, time, ...extraParams));
    }
    // async getRiskiestTrove(...extraParams: T): Promise<TroveWithPendingRedistribution> {
    //   return (
    //     this._cache.getRiskiestTrove(...extraParams) ??
    //     this._readable.getRiskiestTrove(...extraParams)
    //   )
    // }
    async getBalanceERC20(address, ...extraParams) {
        var _a;
        return ((_a = this._cache.getBalanceERC20(address, ...extraParams)) !== null && _a !== void 0 ? _a : this._readable.getBalanceERC20(address, ...extraParams));
    }
    async getLP(address, ...extraParams) {
        var _a;
        return ((_a = this._cache.getLP(address, ...extraParams)) !== null && _a !== void 0 ? _a : this._readable.getLP(address, ...extraParams));
    }
    async getYUSDBalance(address, ...extraParams) {
        var _a;
        return ((_a = this._cache.getYUSDBalance(address, ...extraParams)) !== null && _a !== void 0 ? _a : this._readable.getYUSDBalance(address, ...extraParams));
    }
    async getYETIBalance(address, ...extraParams) {
        var _a;
        return ((_a = this._cache.getYETIBalance(address, ...extraParams)) !== null && _a !== void 0 ? _a : this._readable.getYETIBalance(address, ...extraParams));
    }
    async hasClaimableCollateral(address, ...extraParams) {
        var _a;
        return ((_a = this._cache.hasClaimableCollateral(address, ...extraParams)) !== null && _a !== void 0 ? _a : this._readable.hasClaimableCollateral(address, ...extraParams));
    }
    async getRedemptionBonus(address, ...extraParams) {
        var _a;
        return ((_a = this._cache.getRedemptionBonus(address, ...extraParams)) !== null && _a !== void 0 ? _a : this._readable.getRedemptionBonus(address, ...extraParams));
    }
    async getRedemptionFeeRate(...extraParams) {
        var _a;
        return ((_a = this._cache.getRedemptionFeeRate(...extraParams)) !== null && _a !== void 0 ? _a : this._readable.getRedemptionFeeRate(...extraParams));
    }
    async getReceiptPerUnderlying(address, ...extraParams) {
        var _a;
        return ((_a = this._cache.getReceiptPerUnderlying(address, ...extraParams)) !== null && _a !== void 0 ? _a : this._readable.getReceiptPerUnderlying(address, ...extraParams));
    }
    async getUnderlyingPerReceipt(address, ...extraParams) {
        var _a;
        return ((_a = this._cache.getUnderlyingPerReceipt(address, ...extraParams)) !== null && _a !== void 0 ? _a : this._readable.getUnderlyingPerReceipt(address, ...extraParams));
    }
    async getUnderlyingDecimal(address, ...extraParams) {
        var _a;
        return ((_a = this._cache.getUnderlyingDecimal(address, ...extraParams)) !== null && _a !== void 0 ? _a : this._readable.getUnderlyingDecimal(address, ...extraParams));
    }
    async getUnderlyingToken(address, ...extraParams) {
        var _a;
        return ((_a = this._cache.getUnderlyingToken(address, ...extraParams)) !== null && _a !== void 0 ? _a : this._readable.getUnderlyingToken(address, ...extraParams));
    }
    async getSortedTroveHead(...extraParams) {
        var _a;
        return ((_a = this._cache.getSortedTroveHead(...extraParams)) !== null && _a !== void 0 ? _a : this._readable.getSortedTroveHead(...extraParams));
    }
    async getSortedTroveTail(...extraParams) {
        var _a;
        return ((_a = this._cache.getSortedTroveTail(...extraParams)) !== null && _a !== void 0 ? _a : this._readable.getSortedTroveTail(...extraParams));
    }
    async getSortedTroveSize(...extraParams) {
        var _a;
        return ((_a = this._cache.getSortedTroveSize(...extraParams)) !== null && _a !== void 0 ? _a : this._readable.getSortedTroveSize(...extraParams));
    }
    async getSortedTroveNext(id, ...extraParams) {
        var _a;
        return ((_a = this._cache.getSortedTroveNext(id, ...extraParams)) !== null && _a !== void 0 ? _a : this._readable.getSortedTroveNext(id, ...extraParams));
    }
    async getSortedTrovePrev(id, ...extraParams) {
        var _a;
        return ((_a = this._cache.getSortedTrovePrev(id, ...extraParams)) !== null && _a !== void 0 ? _a : this._readable.getSortedTrovePrev(id, ...extraParams));
    }
    async getCurrentAICR(borrower, ...extraParams) {
        var _a;
        return ((_a = this._cache.getCurrentAICR(borrower, ...extraParams)) !== null && _a !== void 0 ? _a : this._readable.getCurrentAICR(borrower, ...extraParams));
    }
    async getTroveDebt(borrower, ...extraParams) {
        var _a;
        return ((_a = this._cache.getTroveDebt(borrower, ...extraParams)) !== null && _a !== void 0 ? _a : this._readable.getTroveDebt(borrower, ...extraParams));
    }
    async getAllowanceOf(owner, token, spender, amount, ...extraParams) {
        var _a;
        return ((_a = this._cache.getAllowanceOf(owner, token, spender, amount, ...extraParams)) !== null && _a !== void 0 ? _a : this._readable.getAllowanceOf(owner, token, spender, amount, ...extraParams));
    }
    async getYusdAllowance(from, to, amount, ...extraParams) {
        var _a;
        return ((_a = this._cache.getYusdAllowance(from, to, amount, ...extraParams)) !== null && _a !== void 0 ? _a : this._readable.getYusdAllowance(from, to, amount, ...extraParams));
    }
    async getYETIPrice(...extraParams) {
        var _a;
        return ((_a = this._cache.getYETIPrice(...extraParams)) !== null && _a !== void 0 ? _a : this._readable.getYETIPrice(...extraParams));
    }
    async getYUSDPrice(...extraParams) {
        var _a;
        return ((_a = this._cache.getYUSDPrice(...extraParams)) !== null && _a !== void 0 ? _a : this._readable.getYUSDPrice(...extraParams));
    }
    async getGlobalBoostFactor(...extraParams) {
        var _a;
        return ((_a = this._cache.getGlobalBoostFactor(...extraParams)) !== null && _a !== void 0 ? _a : this._readable.getGlobalBoostFactor(...extraParams));
    }
    async getDecayedBoost(address, ...extraParams) {
        var _a;
        return ((_a = this._cache.getDecayedBoost(address, ...extraParams)) !== null && _a !== void 0 ? _a : this._readable.getDecayedBoost(address, ...extraParams));
    }
    // async getUniTokenBalance(address?: string, ...extraParams: T): Promise<Decimal> {
    //   return (
    //     this._cache.getUniTokenBalance(address, ...extraParams) ??
    //     this._readable.getUniTokenBalance(address, ...extraParams)
    //   );
    // }
    // async pngGetUniTokenBalance(address?: string, ...extraParams: T): Promise<Decimal> {
    //   return (
    //     this._cache.pngGetUniTokenBalance(address, ...extraParams) ??
    //     this._readable.pngGetUniTokenBalance(address, ...extraParams)
    //   );
    // }
    // async tjGetUniTokenBalance(address?: string, ...extraParams: T): Promise<Decimal> {
    //   return (
    //     this._cache.tjGetUniTokenBalance(address, ...extraParams) ??
    //     this._readable.tjGetUniTokenBalance(address, ...extraParams)
    //   );
    // }
    // async getUniTokenAllowance(address?: string, ...extraParams: T): Promise<Decimal> {
    //   return (
    //     this._cache.getUniTokenAllowance(address, ...extraParams) ??
    //     this._readable.getUniTokenAllowance(address, ...extraParams)
    //   );
    // }
    // async pngGetUniTokenAllowance(address?: string, ...extraParams: T): Promise<Decimal> {
    //   return (
    //     this._cache.pngGetUniTokenAllowance(address, ...extraParams) ??
    //     this._readable.pngGetUniTokenAllowance(address, ...extraParams)
    //   );
    // }
    // async tjGetUniTokenAllowance(address?: string, ...extraParams: T): Promise<Decimal> {
    //   return (
    //     this._cache.tjGetUniTokenAllowance(address, ...extraParams) ??
    //     this._readable.tjGetUniTokenAllowance(address, ...extraParams)
    //   );
    // }
    // async getRemainingLiquidityMiningYETIReward(...extraParams: T): Promise<Decimal> {
    //   return (
    //     this._cache.getRemainingLiquidityMiningYETIReward(...extraParams) ??
    //     this._readable.getRemainingLiquidityMiningYETIReward(...extraParams)
    //   );
    // }
    // async pngGetRemainingLiquidityMiningYETIReward(...extraParams: T): Promise<Decimal> {
    //   return (
    //     this._cache.pngGetRemainingLiquidityMiningYETIReward(...extraParams) ??
    //     this._readable.pngGetRemainingLiquidityMiningYETIReward(...extraParams)
    //   );
    // }
    // async tjGetRemainingLiquidityMiningYETIReward(...extraParams: T): Promise<Decimal> {
    //   return (
    //     this._cache.tjGetRemainingLiquidityMiningYETIReward(...extraParams) ??
    //     this._readable.tjGetRemainingLiquidityMiningYETIReward(...extraParams)
    //   );
    // }
    // async getLiquidityMiningStake(address?: string, ...extraParams: T): Promise<Decimal> {
    //   return (
    //     this._cache.getLiquidityMiningStake(address, ...extraParams) ??
    //     this._readable.getLiquidityMiningStake(address, ...extraParams)
    //   );
    // }
    // async pngGetLiquidityMiningStake(address?: string, ...extraParams: T): Promise<Decimal> {
    //   return (
    //     this._cache.pngGetLiquidityMiningStake(address, ...extraParams) ??
    //     this._readable.pngGetLiquidityMiningStake(address, ...extraParams)
    //   );
    // }
    // async tjGetLiquidityMiningStake(address?: string, ...extraParams: T): Promise<Decimal> {
    //   return (
    //     this._cache.tjGetLiquidityMiningStake(address, ...extraParams) ??
    //     this._readable.tjGetLiquidityMiningStake(address, ...extraParams)
    //   );
    // }
    // async getTotalStakedUniTokens(...extraParams: T): Promise<Decimal> {
    //   return (
    //     this._cache.getTotalStakedUniTokens(...extraParams) ??
    //     this._readable.getTotalStakedUniTokens(...extraParams)
    //   );
    // }
    // async pngGetTotalStakedUniTokens(...extraParams: T): Promise<Decimal> {
    //   return (
    //     this._cache.pngGetTotalStakedUniTokens(...extraParams) ??
    //     this._readable.pngGetTotalStakedUniTokens(...extraParams)
    //   );
    // }
    // async tjGetTotalStakedUniTokens(...extraParams: T): Promise<Decimal> {
    //   return (
    //     this._cache.tjGetTotalStakedUniTokens(...extraParams) ??
    //     this._readable.tjGetTotalStakedUniTokens(...extraParams)
    //   );
    // }
    // async getLiquidityMiningYETIReward(address?: string, ...extraParams: T): Promise<Decimal> {
    //   return (
    //     this._cache.getLiquidityMiningYETIReward(address, ...extraParams) ??
    //     this._readable.getLiquidityMiningYETIReward(address, ...extraParams)
    //   );
    // }
    // async pngGetLiquidityMiningYETIReward(address?: string, ...extraParams: T): Promise<Decimal> {
    //   return (
    //     this._cache.pngGetLiquidityMiningYETIReward(address, ...extraParams) ??
    //     this._readable.pngGetLiquidityMiningYETIReward(address, ...extraParams)
    //   );
    // }
    // async tjGetLiquidityMiningYETIReward(address?: string, ...extraParams: T): Promise<Decimal> {
    //   return (
    //     this._cache.tjGetLiquidityMiningYETIReward(address, ...extraParams) ??
    //     this._readable.tjGetLiquidityMiningYETIReward(address, ...extraParams)
    //   );
    // }
    async getCollateralSurplusBalancee(...extraParams) {
        var _a;
        return ((_a = this._cache.getCollateralSurplusBalancee(...extraParams)) !== null && _a !== void 0 ? _a : this._readable.getCollateralSurplusBalancee(...extraParams));
    }
    async getTroves(params, ...extraParams) {
        var _a;
        const { beforeRedistribution, ...restOfParams } = params;
        const [totalRedistributed, troves] = await Promise.all([
            beforeRedistribution ? undefined : this.getTotalRedistributed(...extraParams),
            (_a = this._cache.getTroves({ beforeRedistribution: true, ...restOfParams }, ...extraParams)) !== null && _a !== void 0 ? _a : this._readable.getTroves({ beforeRedistribution: true, ...restOfParams }, ...extraParams)
        ]);
        if (totalRedistributed) {
            return troves.map(trove => trove.applyRedistribution(totalRedistributed));
        }
        else {
            return troves;
        }
    }
    async getFees(...extraParams) {
        var _a;
        return (_a = this._cache.getFees(...extraParams)) !== null && _a !== void 0 ? _a : this._readable.getFees(...extraParams);
    }
    async getVaultTokens(whitelistedCollaterals, ...extraParams) {
        var _a;
        return ((_a = this._cache.getVaultTokens(whitelistedCollaterals, ...extraParams)) !== null && _a !== void 0 ? _a : this._readable.getVaultTokens(whitelistedCollaterals, ...extraParams));
    }
    async getWhitelistedCollaterals(...extraParams) {
        var _a;
        return ((_a = this._cache.getWhitelistedCollaterals(...extraParams)) !== null && _a !== void 0 ? _a : this._readable.getWhitelistedCollaterals(...extraParams));
    }
    async getICR(userAddress, ...extraParams) {
        var _a;
        return ((_a = this._cache.getICR(userAddress, ...extraParams)) !== null && _a !== void 0 ? _a : this._readable.getICR(userAddress, ...extraParams));
    }
    async getVcValue(userAddress, ...extraParams) {
        var _a;
        return ((_a = this._cache.getVcValue(userAddress, ...extraParams)) !== null && _a !== void 0 ? _a : this._readable.getVcValue(userAddress, ...extraParams));
    }
    async getSafetyRatios(addresses, ...extraParams) {
        var _a;
        return ((_a = this._cache.getSafetyRatios(addresses, ...extraParams)) !== null && _a !== void 0 ? _a : this._readable.getSafetyRatios(addresses, ...extraParams));
    }
    async getRecoveryRatios(addresses, ...extraParams) {
        var _a;
        return ((_a = this._cache.getRecoveryRatios(addresses, ...extraParams)) !== null && _a !== void 0 ? _a : this._readable.getRecoveryRatios(addresses, ...extraParams));
    }
    async getDecimals(addresses, ...extraParams) {
        var _a;
        return ((_a = this._cache.getDecimals(addresses, ...extraParams)) !== null && _a !== void 0 ? _a : this._readable.getDecimals(addresses, ...extraParams));
    }
}
exports._CachedReadableLiquity = _CachedReadableLiquity;
//# sourceMappingURL=_CachedReadableLiquity.js.map